// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 443 ? "about" : chunkId) + "." + {"21":"fd46bd03","242":"ea366b6e","443":"9f5eaed1","623":"600294cd","738":"2d957857","821":"76380d91","926":"4ef3e530","962":"f8b833ec"}[chunkId] + ".js";
};